import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 訪問予定/結果データ一覧
 *
 * 自分が所持している訪問予定/結果の一覧を返す
 */
export class FetchSchedule implements APIRequest<Monitaro.FetchScheduleResponse> {
  response: Monitaro.FetchScheduleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/schedules`
  }
}

/**
 * アポイントメント申請
 *
 * 病院管理者からアポイントの申請を行う
 */
export class PostSchedule implements APIRequest<Monitaro.PostScheduleResponse> {
  response: Monitaro.PostScheduleResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.ScheduleRequest
  constructor(params: Monitaro.ScheduleRequest) {
    this.params = params
    this.path = `/schedules`
  }
}

/**
 * 訪問予定/結果データの取得
 *
 * 指定された訪問予定/結果IDのデータを取得する&lt;br&gt;
保有していないアポイントメントIDの場合はステータス404を返す
 */
export class GetSchedule implements APIRequest<Monitaro.GetScheduleResponse> {
  response: Monitaro.GetScheduleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(appointment: string) {
    this.path = `/schedules/${appointment}`
  }
}

/**
 * アポイントメントデータの更新
 *
 * アポイントメントのデータの更新を行う
 */
export class PutSchedule implements APIRequest<Monitaro.PutScheduleResponse> {
  response: Monitaro.PutScheduleResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.ScheduleRequest
  constructor(appointment: string, params: Monitaro.ScheduleRequest) {
    this.params = params
    this.path = `/schedules/${appointment}`
  }
}

/**
 * アポイントメント削除
 *
 * 指定されたアポイントメントを削除する
 */
export class DeleteSchedule implements APIRequest<Monitaro.DeleteScheduleResponse> {
  response: Monitaro.DeleteScheduleResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  params?: { target?: 'result' | 'schedule' }
  constructor(appointment: string, target?: 'result' | 'schedule') {
    this.path = `/schedules/${appointment}`
    if (target) {
      this.params = { target }
    }
  }
}
